import React from "react";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles";

export interface Props {
  variant: string;
  text: string;
  title?: string;
  className?: string;
}

const Snack = ({ text, variant, className, title }: Props) => {
  const classes = useStyles();
  return (
    <Typography
      component={"div"}
      className={clsx(classes.root, classes[variant], className)}
      title={title}
    >
      {text}
    </Typography>
  );
};

export default Snack;
